/**
 * Mosaic template.
 */
import Description from '@components/sections/description/description';
import Empty from '@components/pages/empty';
import Grid from '../../../sections/grid/ui/grid';
import MosaicContext from '@shared/components/utils/context/mosaicContext';
import MosaicProps from '@shared/types/props/mosaic';
import useMosaic from '../lib/useMosaic';
import { ContextType } from '@shared/types/enums/context';

/**
 * Displays a mosaic of items.
 */
export default function MosaicTemplate(props: MosaicProps) {
  const context = useMosaic(props);
  const { data } = context;
  if (props.flags?.complete && !data?.length) {
    return <Empty />;
  }
  return (
    <MosaicContext.Provider value={context}>
      <Description type={ContextType.MOSAIC} />
      <Grid />
    </MosaicContext.Provider>
  );
}
